<template>
  <div>
    <!-- {{ scope.row.orderId }} -->
    <el-table
      :data="contactHistory"
      style="width: 100%"
      :render-header="renderHeader"
      height="calc(100vh - 353px)"
      @sort-change="handleSort"
      :row-class-name="tableRowClassName"
    >
      <el-table-column
        prop="userId"
        label="用户ID"
        align="left"
        min-width="170"
      >
        <template slot-scope="scope">
          {{ scope.row.userId }}
        </template>
      </el-table-column>
      <el-table-column prop="tenantId" label="商户ID" align="left">
        <template slot-scope="scope">
          {{ scope.row.tenantId }}
        </template>
      </el-table-column>
      <el-table-column
        prop="invitedUserId"
        label="邀请人ID"
        align="center"
        min-width="170"
      >
        <template slot-scope="scope">
          {{ scope.row.invitedUserId }}
        </template>
      </el-table-column>
      <el-table-column
        prop="community"
        label="归属社区"
        align="center"
        min-width="170"
      >
        <template slot-scope="scope">
          {{ scope.row.community }}
        </template>
      </el-table-column>

      <el-table-column label="用户状态">
        <template slot-scope="scope">
          <span class="take" v-if="scope.row.status">正常</span>
          <span class="take" v-if="!scope.row.status">黑名单</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="rewardTotal"
        label="奖励金总量"
        align="center"
        min-width="170"
      >
        <template slot-scope="scope">
          {{ scope.row.rewardTotal }}
        </template>
      </el-table-column>
      <el-table-column
        prop="rewardClaimed"
        label="奖励已领取"
        align="left"
        min-width="170"
      >
        <template slot-scope="scope">
          {{ scope.row.rewardClaimed }}
        </template>
      </el-table-column>
    </el-table>
    <div class="pag">
      <pagination
        :size="pagination.size"
        :total="totalCount"
        :page="pagination.page"
        @pageChanged="pageChanged"
      ></pagination>
    </div>
    <!-- <update-dialog
      :val="userinfoDetail"
      :updateForm="updateForm"
    ></update-dialog> -->

    <UserDetailDialog :id="id" :type="type" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import Pagination from 'components/pagination'
import updateDialog from '../updatedialog'
import order from '@/assets/order.png'
import copyImg from '@/assets/copy.png'
import UserDetailDialog from 'components/userDetailDialog'
import { positionOrderList } from '@/common/publicApi'
import tip from '@/assets/partnerCenter/tip.png'
export default {
  name: 'ContactHistoryList',
  data() {
    return {
      updateForm: {},
      updateUserTypeDialogVisible: false,
      newUserType: '',
      selectedForUserType: {},
      centerDialogVisible: false,
      textarea2: '',
      order,
      tip,
      copyImg,
      type: '',
      id: '',
      cacheRow: {},
      orderList: [],
      orderVisible: false,
      orderPage: {
        page: 1,
        size: 10,
      },
      orderTotal: 0,
    }
  },
  components: {
    Pagination,
    UserDetailDialog,
    updateDialog,
  },
  methods: {
    ...mapActions('closingCommission', ['addRemark']),
    // ...mapActions('userData', ['getHistory']),

    ...mapMutations('closingCommission', [
      'setUserinfoDetailDialogVisible',
      'setUserinfoDetail',
    ]),
    ...mapMutations('contractassets', ['setUserDetailInfoVisible']),
    ...mapMutations('userData', ['setPagination', 'setOrderBy']),
    // getContactHistory() {
    //   this.getHistory()
    // },
    renderHeader(h, { column, $index }) {
      // 新建一个 span
      let span = document.createElement('span')
      // 设置表头名称
      span.innerText = column.label
      // 临时插入 document
      document.body.appendChild(span)
      // 重点：获取 span 最小宽度，设置当前列，注意这里加了 20，字段较多时还是有挤压，且渲染后的 div 内左右 padding 都是 10，所以 +20 。（可能还有边距/边框等值，需要根据实际情况加上）
      column.minWidth = span.getBoundingClientRect().width + 20
      // 移除 document 中临时的 span
      document.body.removeChild(span)
      return h('span', column.label)
    },

    copy(data) {
      let url = data
      let oInput = document.createElement('input')
      oInput.value = url
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      console.log(oInput.value)
      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message({
        message: '复制成功',
        type: 'success',
        center: true,
      })
      oInput.remove()
    },
    pageChanged(pagination) {
      this.setPagination(pagination)
      this.$emit('refresh', { ...pagination })
    },
    handleUpdate(row) {
      this.updateForm = row
      // this.setUserinfoDetail(row);
      // this.setUserinfoDetailDialogVisible(true);
      this.centerDialogVisible = true
      this.textarea2 = row.remarks
    },
    add() {
      this.addRemark({
        channelId: this.userInfo.channelId,
        userId: this.updateForm.id,
        remarks: this.textarea2,
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success('添加成功')
          ;(this.textarea2 = ''), (this.centerDialogVisible = false)
          this.$emit('refresh')
        }
      })
    },
    goDetail(row) {
      this.$router.push({ path: `/home/closingCommission/detail`, query: row })
    },

    copy(data) {
      let url = data
      let oInput = document.createElement('input')
      oInput.value = url
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      console.log(oInput.value)
      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message({
        message: '复制成功',
        type: 'success',
        center: true,
      })
      oInput.remove()
    },
    showBox(row, type) {
      this.type = type
      this.id = type == 2 ? row.userId : row.channelUserId
      this.setUserDetailInfoVisible(true)
    },
    handleSort({ column, prop, order }) {
      this.setOrderBy(null)
      if (order) {
        const orderSort = order === 'descending' ? 'desc' : 'asc'
        this.setOrderBy(`${prop},${orderSort}`)
      }
      this.$emit('refresh')
    },
    getOrderList() {
      positionOrderList({
        positionId: this.cacheRow.id,
        ...this.orderPage,
      }).then((res) => {
        if (res.code == 0) {
          this.orderList = res.data.list
          this.orderTotal = res.data.totalCount
        }
      })
    },
    colseOrder() {
      this.cacheRow = {}
      this.orderPage = {
        page: 1,
        size: 10,
      }
      this.orderTotal = 0
      this.orderVisible = false
    },
    showOrder(row) {
      this.cacheRow = row
      this.orderVisible = true
      this.getOrderList()
    },
    orderPageChanged(pagination) {
      this.orderPage = pagination
      this.getOrderList()
    },
    transform(str) {
      if (str) {
        return str.split('_')[0].toUpperCase()
      }
      return ''
    },
    tableRowClassName({ row }) {
      if (row.mark == true) {
        return 'redRow'
      }
      return ''
    },
  },
  computed: {
    // ...mapGetters('user', ['contactHistory']),
    ...mapState(['userInfo']),
    ...mapState('userData', [
      'pagination',
      'contactHistory',
      'totalCount',
      'orderBy',
    ]),
  },
}
</script>

<style lang="less" src="../../../../../styles/table.less" scoped></style>
<style lang="less" scoped>
.green {
  color: skyblue;
}
.red {
  color: #f54a45;
}
</style>
